module.exports = __webpack_public_path__ + "static/media/logcontent.f91f7461.PNG";